export default __webpack_public_path__ + "static/media/bg.034d42b5.png";